import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import * as THREE from "three";
import { Extrude, Edges } from "@react-three/drei";
import ImagePlan from "./ImagePlan";
import Text3d from "./Text3d";
import {
  createSearchParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { GVarState } from "../StoreState/Gstate";
import gsap from "gsap";
import { useThree } from "@react-three/fiber";
import { activeClick, groupRef } from "../StoreState/Var";

function ShapBox(props) {
  let { d, d: { point }, index } = props;
  const navigate = useNavigate();
  const g = useContext(GVarState);
  window.g = g
  let { camera, controls } = useThree();
  const shapRef = useRef();
  const [searchParams] = useSearchParams();
  const [pointDownContent, setPointDownContent] = useState(false);
  const [pointDragContent, setPointDragContent] = useState(false);

  const shape = React.useMemo(() => {

    const _shape = new THREE.Shape();
    point.shape?.map((d, i) => {
      if (i === 0) {
        _shape.moveTo(d.x / 10, d.y / 10);
      } else {
        _shape.lineTo(d.x / 10, d.y / 10);
      }
    });
    return _shape;
  }, []);

  const extrudeSettings = {
    steps: 2,
    depth: point.floorBash ? 0 : 3,
    bevelEnabled: false,
  };


  useEffect(() => {
    if (g.path.length && g.selectShapData?.name === d.name && g.selectShapData.z === g.CurrentFloor) {
      let newBox = new THREE.Box3().setFromObject(shapRef.current);
      const vector = new THREE.Vector3();
      let xyz = newBox.getCenter(vector);
      g.setpinArray([xyz])
    }
  }, [g.path]);


  useEffect(() => {
    if (shapRef.current) {
      shapRef.current.point = point
    }

  }, [])


const darkColor = "#666666" // 
  return (
    <React.Fragment key={index}>
      {point.logo?.show && (
        <ImagePlan logo={point.logo} flickering={point.extra?.flickering ? 0.2 : 0} />
      )}
      <Extrude
        ref={shapRef}
        rotation={[Math.PI / 2, 0, 0]}
        args={[shape, extrudeSettings]}
        position={[
          0,
          point.floorBash
            ? 0 + (point.extra?.flickering ? 0.2 : 0)
            : 3 + (point.extra?.flickering ? 0.2 : 0),
          0,
        ]}

        onDoubleClick={(e) => {
          e.stopPropagation()
        }}

        onClick={(e) => {
          e.stopPropagation();
          if (!point.floorBash && activeClick) {
            if (d.point.LocationName?.text && d.point.LocationName?.text?.trim().length > 0 && g.selectShapData?.name !== d.name) {
              let params = {};
              searchParams.forEach((d, i) => {
                if (i == "v" || i == "m") params[i] = d;
              });
              let selectData = btoa(`${d.x},${d.y},${d.z}`);
              params.selectData = selectData;
              navigate({
                pathname: "/",
                search: `?${createSearchParams(params)}`,
              });
            }
          } else {
            // if(activeClick){
            //   controls.target.set(g.defaultPosition?.x, g.defaultPosition?.y, g.defaultPosition?.z)
            //   camera.position.set(g.defaultPosition?.x, 150, g.defaultPosition?.z)
            //   // controls.reset();
            // }
            // g.pinRef.current.visible = false
          }

        }}
      >
         <meshStandardMaterial
            // color={point.color}
            color={g.path.length ?
              g.selectShapData?.name === d.name ? '#f54a14' :
                g.selectPointA?.name === d.name ? '#859ada' : point.color :
              (point?.LocationName?.text === g.selectShapData?.point?.LocationName?.text && g.selectShapData?.point?.LocationName?.text) ? '#f54a14' : point.color
            }
            attach="material-0"
            opacity={1}

          />
       
 <meshStandardMaterial attach="material-1" color={darkColor} opacity={1} />
  <meshStandardMaterial attach="material-2" color={darkColor} opacity={1} />


        <Edges color={"gray"} />
        {point.LocationName && point.LocationName.textSize !== "0" && (
          <>
            <Text3d
              point={point}
              LocationName={point.LocationName}
            />
          </>
        )}
      </Extrude>
    </React.Fragment>
  );
}

export default ShapBox;

